// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__1A_GF","icon":"link_icon__2T14B","linkContent":"link_linkContent__BRWNI"};